import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import React, { useEffect, useState } from 'react';
import emailIcon from '../../../../assets/icons/Email.svg';
import './userDrawer.scss';
// import InfoIcon from '../../../../assets/icons/info.svg';
import { useAuth0 } from '@auth0/auth0-react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Avatar from '@mui/material/Avatar';
import { useRadioGroup } from "@mui/material/RadioGroup";
import user from 'assets/icons/user.jpg';
import { LabelField } from 'components/LabelField';
import Selection from 'components/Selection/Selection';
import { toastr } from 'react-redux-toastr';
import styled from 'styled-components';
import UserService from '../../../../Lib/API/users';
import IconX from '../../../../assets/icons/ComponentX.svg';
import IconY from '../../../../assets/icons/ComponentY.svg';
import cameraIcon from '../../../../assets/icons/camera_icon.svg';
import Action from '../../../../components/ActionPopOver';
import MyButton from '../../../../components/MyButton';
import { SelectField } from '../../../../components/SelectFields/SelectField';
import VacationBox from '../addUserDrawer/VacationBox';
import { fontConfig } from "theme/fontConfig";
import InfoTooltip from "components/InfoTooltip";


const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": checked && {
    color: theme?.palette?.primary?.main,
  },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const UserDrawer = ({
  drawerData,
  setOpenShabbat,
  openShabbat,
  setOpenVacation,
  openVacation,
  setUpdateUserRow,
  setIsUpdateUserDrawerOpen,
  setAnchorEl,
  setRefresh,
  refresh,
  setOpenAlertDelete,
  setDeleteHandle,
  deleteHandle,
  setOpenAlertBlock,
  setblockHandle,
  blockHandle,
  setUserId,
  userId,
  setBlockedRow,
  usersData,
  eventUserLoading,
}) => {
  const [loading, setLoading] = useState(false);
  const [listModules, setListModules] = useState([]);
  const [vacation, setVacation] = useState('');
  const { getAccessTokenSilently } = useAuth0();
  const [selectedModule, setSelectedModule] = useState({
    pastoral: {},
    finance: {},
    education: {},
    members: {},
    report: {},
    settings: {},
    "user management": {},
  });
  const subModuleActiveElement = {
    vacation: {
      active: true,
      component: <VacationBox 
        usersData={usersData} 
        eventUserLoading={eventUserLoading} 
        setSelectedModule={setSelectedModule}
        selectedModule={selectedModule}
        isDisabled={true}
      />
    }
  }
  // for test
  const selectUserTest = [
    <div className="d-flex align-items-center">
      <img
        src={user}
        alt=""
        style={{
          width: '31px',
          height: '31px',
          borderRadius: '50%',
        }}
      />{' '}
      <span className="d-flex align-items-center ml-2">Amran test 1</span>
    </div>,
    <div className="d-flex alien-items-center">
      <img
        src={user}
        alt=""
        style={{
          width: '31px',
          height: '31px',
          borderRadius: '50%',
        }}
      />{' '}
      <span className="d-flex align-items-center ml-2">Amran test 2</span>
    </div>,
    <div className="d-flex align-items-center">
      <img
        src={user}
        alt=""
        style={{
          width: '31px',
          height: '31px',
          borderRadius: '50%',
        }}
      />{' '}
      <span className="d-flex align-items-center ml-2">Amran test 3</span>
    </div>,
    <div className="d-flex align-items-center">
      <img
        src={user}
        alt=""
        style={{
          width: '31px',
          height: '31px',
          borderRadius: '50%',
        }}
      />{' '}
      <span className="d-flex align-items-center ml-2">Amran test 4</span>
    </div>,
  ];
  const getAuthorizedModules = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    await UserService.authorizedModules(token).then((res) => {
      setListModules(res.result);
      setLoading(false);
    });
  };

  useEffect(() => {
    getAuthorizedModules();
  }, []);


  console.log('drawerData :', drawerData);
  useEffect(() => {
    if(!usersData?.length && eventUserLoading) return;
    const formattedModules = drawerData?.authorizedModules?.reduce(
      (acc, item) => {
        acc[item.moduleName] = {
          ...item,
          active: item.active,
          description: usersData?.length ? usersData?.find((user) => user.value == item.description) : null,
          subModule: item.subModule?.reduce(
            (subAcc, subItem) => {
              subAcc[subItem.subModuleName] = {
                ...subItem,
                active: subItem.active,
                description: usersData?.length ? usersData?.find((user) => user.value == subItem.description) : null,
              };
              return subAcc;
            },
            {}
          ),
        };
        return acc;
      },
      {}
    );
    
    setSelectedModule(formattedModules);
  }, [usersData,drawerData]);


  

  return (
    <Box
      width="570px"
      textAlign="center"
      role="presentation"
      sx={{ padding: '28px 45px', fontFamily: fontConfig.SettingsUserDrawerTextFont.family }}
    >
      <div className="popover__drawer">
        <IconButton className="p-0 px-2">
          <Action
            onEditClick={() => {
              setUpdateUserRow(drawerData);
              setIsUpdateUserDrawerOpen(true);
              setAnchorEl(null);
            }}
            // onActiveClick={() => {}}
            onDeleteClick={() => {}}
            style={{
              width: '16px',
              height: '16px',
            }}
            // checkActive={true}
            action={'userAction'}
            setUpdateUserRow={setUpdateUserRow}
            setIsUpdateUserDrawerOpen={setIsUpdateUserDrawerOpen}
            row={drawerData}
            setRefresh={setRefresh}
            refresh={refresh}
            setOpenAlertDelete={setOpenAlertDelete}
            setDeleteHandle={setDeleteHandle}
            deleteHandle={deleteHandle}
            setOpenAlertBlock={setOpenAlertBlock}
            setblockHandle={setblockHandle}
            blockHandle={blockHandle}
            setUserId={setUserId}
            userId={userId}
            setBlockedRow={setBlockedRow}
            MoreVert={'MoreVert'}
            activeUesr={drawerData?.active}
          />
        </IconButton>
      </div>

      <div className="d-flex justify-content-center flex-column user__drawer__content">
        <div className="img__user__drawer mt-3">
          {drawerData.profile_img ? (
            <>
              <img
                src={drawerData.profile_img}
                alt="drawerUserImg"
                style={{
                  width: '113px',
                  height: '113px',
                  borderRadius: '50%',
                }}
              />
            </>
          ) : (
            <Avatar
              sx={{
                width: '113px',
                height: '113px',
                fontSize: '30px',
                fontFamily: fontConfig.SettingsAvatarFont.family,
                fontWeight: '500',
              }}
            >
              {drawerData?.name?.substring(0, 2)}
            </Avatar>
          )}
          <img src={cameraIcon} alt="cameraIcon" className="cameraIcon" />
        </div>
        <div className="drawer__head__title">
          <p
            style={{
              color: '#002E5C',
              fontFamily: fontConfig.SettingsUserDrawerTextFont.family,
              fontSize: '24px',
              fontWeight: '600',
              margin: '0',
            }}
          >
            {drawerData.name}
          </p>
          <p
            style={{
              color: '#9FA0A2',
              fontSize: '12px',
              fontWeight: '400',
              textTransform: 'capitalize',
              fontFamily: fontConfig.SettingsUserDrawerTextFont.family,
            }}
          >
            {drawerData.role}
          </p>
        </div>
        <div className="email__drawer__btn mt-3 w-100">
          <button>
            <span>
              <img
                src={emailIcon}
                alt="emailIcon"
                style={{ width: '30px', height: '20px' }}
              />
            </span>
            {drawerData.email}
          </button>
        </div>
        <Divider sx={{ marginTop: '24px', marginBottom: '24px' }} />
        <div className="drawer__user__permmistions__list">
          <p
            className="mt-3 mb-3 ml-2 d-flex align-items-center"
            style={{
              color: '#4d5565',
              fontFamily: fontConfig.SettingsUserDrawerTextFont.family,
              fontWeight: '400',
              fontSize: '14px',
              textAlign: 'left',
              gap: '6px',
            }}
          >
            PERMISSIONS
            <InfoTooltip text="For each module, Admin gives this staff user full access and Disable gives none. There is no partial or view-only access." placement="bottom" />
          </p>
          <div className="drawer__user__permmistions__list__items">
            {listModules.length === 0 ? (
              loading ? (
                <p>loading...</p>
              ) : (
                <p>No Modules Available</p>
              )
            ) : (
              listModules.map(
                ({ moduleName, _id, subModule, available }, ndx) => {
                  const isLast = listModules.length - 1 === ndx;
                  return (
                    <>
                      <div
                        className={
                          subModule.length > 0
                            ? 'drawer__user__permmistions__list__item subModuleCursor'
                            : 'drawer__user__permmistions__list__item'
                        }
                        key={_id}
                        onClick={() =>
                          subModule.length > 0
                            ? setOpenShabbat(!openShabbat)
                            : ''
                        }
                      >
                        <div
                          className={`role__field ${
                            !available ? "disable__module" : ""
                          }`}
                        >
                          {moduleName}
                        </div>
                        <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="Members"
                          name={moduleName}
                          value={selectedModule[moduleName]?.active || false}
                          onChange={(e) =>
                            setSelectedModule((prev) => ({
                              ...prev,
                              [moduleName]: {
                                ...prev[moduleName],
                                active: e.target.value === 'true' ? true : false,
                              },
                            }))
                          }
                          defaultValue={selectedModule[moduleName]?.active || false}
                        >
                          <MyFormControlLabel
                            value={true}
                            control={<Radio size="small" disabled={true} />}
                            label="Admin"
                          />
                          <MyFormControlLabel
                            value={false}
                            control={<Radio size="small" disabled={true} />}
                            label="Disable"
                          />
                        </RadioGroup>
                      </FormControl>
                        {/* <p
                          className={
                            drawerData?.authorizedModules?.find(
                              (item) => item.moduleName === moduleName
                            )
                              ? drawerData?.authorizedModules?.find(
                                  (item) => item.moduleName === moduleName
                                )?.active
                                ? 'admin_role'
                                : 'disabled_role'
                              : 'disabled_role'
                          }
                        >
                          {drawerData?.authorizedModules?.find(
                            (item) => item.moduleName === moduleName
                          )
                            ? drawerData?.authorizedModules?.find(
                                (item) => item.moduleName === moduleName
                              )?.active
                              ? 'Admin'
                              : 'Disabled'
                            : 'Disabled'}
                        </p> */}
                      </div>
                      {(subModule?.length > 0 && selectedModule[moduleName]?.active) && (
                        <div className="shabbat">
                          <div
                            className="form-group mt-5"
                            style={{
                              textAlign: 'left',
                            }}
                          >
                            <LabelField
                              title={"Clergy type"}
                              style={{
                                fontSize: "12px",
                              }}
                              mandatory={false}
                            />
                            <Selection
                              name="clergyType"
                              mandatory={false}
                              placeholder="Select a clergy"
                              options={usersData}
                              isLoading={eventUserLoading}
                              style={"secondary"}
                              onChange={(value) => {
                                
                              }}
                              value={selectedModule[moduleName]?.description}
                              isClearable={true}
                              isDisabled={true}
                            />
                          </div>
                          {subModule?.map(({ _id, subModuleName, active }, subIndex) => (
                            <div className='mt-5' key={_id}>
                              <div className="first_field_shabbat">
                                <div className="shabbat__text">{subModuleName}</div>
                                <FormControl>
                                  <RadioGroup
                                    row
                                    aria-labelledby={subModuleName}
                                    name={subModuleName}
                                    value={selectedModule[moduleName]?.subModule?.[subModuleName]?.active ? true : false}
                                    onChange={(e) => {
                                      setSelectedModule((prev) => ({
                                        ...prev,
                                        [moduleName]: {
                                          ...prev[moduleName],
                                          subModule: {
                                            ...prev[moduleName]?.subModule,
                                            [subModuleName]: {
                                              ...prev[moduleName]?.subModule?.[subModuleName],
                                              active: e.target.value === 'true',
                                            },
                                          }
                                        },
                                      }));
                                    }}
                                    defaultValue={selectedModule[moduleName]?.subModule?.[subModuleName]?.active || false}
                                  >
                                    <MyFormControlLabel
                                      value={true}
                                      control={<Radio size="small" disabled={true} />}
                                      label="Yes"
                                    />
                                    <MyFormControlLabel
                                      value={false}
                                      control={<Radio size="small" disabled={true} />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                              {subIndex !== subModule.length - 1 && (
                                <Divider
                                  sx={{
                                    color: '#3F4255',
                                    marginTop: '12px',
                                    marginBottom: '12px',
                                  }}
                                />
                              )}
                              {(selectedModule[moduleName]?.subModule?.[subModuleName]?.active && subModuleActiveElement?.[subModuleName]?.active) ? subModuleActiveElement?.[subModuleName]?.component : null}
                            </div>
                          ))}
                        </div>
                      )}
                      {!isLast && (
                        <Divider
                          sx={{
                            color: '#3F4255',
                            marginTop: '12px',
                            marginBottom: '12px',
                          }}
                        />
                      )}
                    </>
                  );
                }
              )
            )}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default UserDrawer;
